module.exports = __webpack_public_path__ + "static/media/storm.df40c71e.jpg";